import {getAxios} from './axios'
import {responseResolveInterceptor} from 'backend-helpers/interceptors';

export function getProfileAlbum(nick) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/profile/album/',
        method: 'get',
        params: {nick}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profileAlbum.js